import { Box, styled } from '@mui/material';
import { other } from 'assets/colors/colors';
import { CSSProperties } from 'react';

export const imageStyle: CSSProperties = {
  maxWidth: '100%',
  maxHeight: '100%',
  objectFit: 'contain',
  height: '80vh',
};

export const iframeStyle: CSSProperties = {
  maxWidth: '100%',
  maxHeight: '100%',
  width: '800px',
  height: '80vh',
  overflowX: 'hidden',
  overflowY: 'auto',
  border: 'none',
};

export const StyledBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: other.background,
  padding: '5px 24px',
  position: 'sticky',
  top: 0,
  zIndex: 1,
}));
